import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=5ae8ea28&scoped=true"
import script from "./Template.vue?vue&type=script&setup=true&lang=js"
export * from "./Template.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Template.vue?vue&type=style&index=0&id=5ae8ea28&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae8ea28",
  null
  
)

export default component.exports